import { LabelledEntity } from 'shared/types/commonView';

export function isDefinedValue<T>(value: T | null | undefined): value is T {
  return value !== undefined && value !== null;
}

export function normalizeBoolean(
  value: unknown,
  defaultValue: boolean
): boolean {
  return typeof value === 'boolean' ? value : defaultValue;
}

export function isNonEmptyLabelledEntity(
  value: LabelledEntity | null | undefined
): value is LabelledEntity {
  return Boolean(value?._id) && Boolean(value?.label);
}
